import type { CustomTypeOptions, TOptions } from 'i18next'
// biome-ignore lint/style/noRestrictedImports: we need it to override it
import { useTranslation as i18nUseTranslation } from 'react-i18next'
import type { Maybe, Nullable, ObjectPath } from '@/shared/core/types/types.ts'

export type I18nKeys = ObjectPath<CustomTypeOptions['resources']['translation']>

export type TranslateParameters =
	| I18nKeys
	| {
			key: I18nKeys
			options: Maybe<TOptions>
	  }

export function useTranslation() {
	const { i18n, t: translate } = i18nUseTranslation()

	function t(translateParameters: null): null
	function t(translateParameters: TranslateParameters): string
	function t(
		translateParameters: Nullable<TranslateParameters>,
	): Nullable<string> {
		if (translateParameters === null) {
			return null
		}
		if (typeof translateParameters === 'object') {
			return translate(translateParameters.key, translateParameters.options)
		}
		return translate(translateParameters)
	}

	return { i18n, t }
}
